import * as React from "react"

function Seo({ src, children }) {

  if (src !== undefined) {
    return (
      <>
        {src.title ? <title>{src.title}</title> : null}
        {src.metaDes ? <meta name="description" content={src.metaDesc}></meta> : null}
        <meta name="robots" content={`${src.metaRobotsNofollow}, ${src.metaRobotsNoindex}`}></meta>
        {src.canonical !== "" ? <link rel="canonical" href={src.canonical}></link> : null}
        <meta property="og:locale" content={'nl_NL'}></meta>
        {src.opengraphType ? <meta property="og:type" content={src.opengraphType}></meta> : null}
        {src.opengraphTitle ? <meta property="og:title" content={src.opengraphTitle}></meta> : null}
        {src.opengraphDescription ? <meta property="og:description" content={src.opengraphDescription}></meta> : null}
        {src.opengraphUrl ? <meta property="og:url" content={src.opengraphUrl}></meta> : null}
        {src.opengraphSiteName ? <meta property="og:site_name" content={src.opengraphSiteName}></meta> : null}
        {src.opengraphModifiedTime ? <meta property="og:updated_time" content={src.opengraphModifiedTime}></meta> : null}
        {src.opengraphPublishedTime ? <meta property="article:published_time" content={src.opengraphPublishedTime}></meta> : null}
        {src.opengraphModifiedTime ? <meta property="article:modified_time" content={src.opengraphModifiedTime}></meta> : null}
        {src.twitterImage ? <meta property="twitter:card" content={src.twitterImage.mediaItemUrl}></meta> : null}
        {src.twitterTitle ? <meta property="twitter:title" content={src.twitterTitle}></meta> : null}
        {src.twitterDescription ? <meta property="twitter:description" content={src.twitterDescription}></meta> : null}
        {src.opengraphAuthor ? <meta property="twitter:label1" content={"Geschreven door"}></meta> : null}
        {src.opengraphAuthor ? <meta property="twitter:data1" content={src.opengraphAuthor}></meta> : null}
        {src.readingTime ? <meta property="twitter:label2" content={"Tijd om te lezen"}></meta> : null}
        {src.readingTime ? <meta property="twitter:data2" content={src.readingTime}></meta> : null}
        {src.schema ? <script type="application/ld+json">{src.schema.raw}</script> : null}
        {children}
      </>
    )
  }
}

export default Seo
